:root ._dsp-flex{display:flex;}
:root ._items-stretch{align-items:stretch;}
:root ._fd-column{flex-direction:column;}
:root ._fb-auto{flex-basis:auto;}
:root ._bxs-border-box{box-sizing:border-box;}
:root ._minH-0px{min-height:0px;}
:root ._minW-0px{min-width:0px;}
:root ._shrink-0{flex-shrink:0;}
:root ._pos-relative{position:relative;}
:root ._height-10037{height:100%;}
:root ._ml-0px{margin-left:0px;}
:root ._ml-24px{margin-left:24px;}
:root ._cur-pointer{cursor:pointer;}
:root ._btw-1px{border-top-width:1px;}
:root ._brw-1px{border-right-width:1px;}
:root ._borderBottomWidth-1px{border-bottom-width:1px;}
:root ._borderLeftWidth-1px{border-left-width:1px;}
:root ._btc-divider{border-top-color:var(--divider);}
:root ._brc-divider{border-right-color:var(--divider);}
:root ._borderBottomColor-divider{border-bottom-color:var(--divider);}
:root ._borderLeftColor-divider{border-left-color:var(--divider);}
:root ._borderTopStyle-dashed{border-top-style:dashed;}
:root ._borderRightStyle-dashed{border-right-style:dashed;}
:root ._borderBottomStyle-dashed{border-bottom-style:dashed;}
:root ._borderLeftStyle-dashed{border-left-style:dashed;}
:root ._pt-t-space-med104641{padding-top:var(--t-space-medium);}
:root ._pr-t-space-med104641{padding-right:var(--t-space-medium);}
:root ._pb-t-space-med104641{padding-bottom:var(--t-space-medium);}
:root ._pl-t-space-med104641{padding-left:var(--t-space-medium);}
:root ._items-center{align-items:center;}
:root ._minH-80px{min-height:80px;}
:root ._justify-center{justify-content:center;}
:root ._fd-row{flex-direction:row;}
:root ._gap-t-space-med104641{gap:var(--t-space-medium);}
:root ._gap-t-space-sma3456{gap:var(--t-space-small);}
:root ._maxW-600px{max-width:600px;}
:root ._width-10037{width:100%;}
:root ._pt-t-size-medi3736{padding-top:var(--t-size-medium);}
:root ._pr-t-size-medi3736{padding-right:var(--t-size-medium);}
:root ._pb-t-size-medi3736{padding-bottom:var(--t-size-medium);}
:root ._pl-t-size-medi3736{padding-left:var(--t-size-medium);}
:root ._background-fff35{background:#fff;}
:root ._justify-space-betwe3241{justify-content:space-between;}
:root ._shrink-1{flex-shrink:1;}
:root ._grow-1{flex-grow:1;}